/* eslint-disable no-undef */
const DefaultMenuList = [
	{
		label: 'component.menu.home',
		icon: 'IconBringzz',
		folder: 'CustomIcons',
		url: '/home'
	},
	{
		label: 'component.menu.search',
		icon: 'IconSearchAlt',
		folder: 'LineIcons',
		url: '/search'
	},
	{
		label: 'component.menu.scan',
		icon: 'IconBarcode',
		folder: 'LineIcons',
		url: '/scan'
	},
	{
		label: 'component.menu.basket',
		icon: 'IconShoppingBag14',
		folder: 'LineIcons',
		url: '/basket'
	},
	{
		label: 'component.menu.profile',
		icon: 'IconUserAlt1',
		folder: 'LineIcons',
		url: '/settings'
	}
];

const PharmacistMenuList = [
	{
		label: 'component.menu.home',
		icon: 'IconBringzz',
		folder: 'CustomIcons',
		url: '/home'
	},
	{
		label: 'component.menu.search',
		icon: 'IconSearchAlt',
		folder: 'LineIcons',
		url: '/search'
	},
	{
		label: 'component.menu.scan',
		icon: 'IconBarcode',
		folder: 'LineIcons',
		url: '/scan'
	},
	{
		label: 'component.menu.post',
		icon: 'IconCirclePlus',
		folder: 'LineIcons',
		url: '/posts'
	},
	// {
	// 	label: 'component.menu.basket',
	// 	icon: 'IconShoppingBag14',
	// 	folder: 'LineIcons',
	// 	url: '/basket'
	// },
	{
		label: 'component.menu.profile',
		icon: 'IconUserAlt1',
		folder: 'LineIcons',
		url: '/settings'
	}
];

const hoursOptions = [
	{ label: '00', value: 0 },
	{ label: '1', value: 1 },
	{ label: '2', value: 2 },
	{ label: '3', value: 3 },
	{ label: '4', value: 4 },
	{ label: '5', value: 5 },
	{ label: '6', value: 6 },
	{ label: '7', value: 7 },
	{ label: '8', value: 8 },
	{ label: '9', value: 9 },
	{ label: '10', value: 10 },
	{ label: '11', value: 11 },
	{ label: '12', value: 12 },
	{ label: '13', value: 13 },
	{ label: '14', value: 14 },
	{ label: '15', value: 15 },
	{ label: '16', value: 16 },
	{ label: '17', value: 17 },
	{ label: '18', value: 18 },
	{ label: '19', value: 19 },
	{ label: '20', value: 20 },
	{ label: '21', value: 21 },
	{ label: '22', value: 22 },
	{ label: '23', value: 23 },
	{ label: '24', value: 24 }
];

const generateMinutesOptions = () => {
	let array = [];
	for (let index = 0; index < 60; index++) {
		array.push({ value: index, label: index.toString().padStart(2, '0') });
	}
	return array;
};
const minutesOptions = generateMinutesOptions();

const INSTRUCTIONS = {
	PACKAGE_ORDER_PROCESSING_SCANNING_INSTRUCTIONS: {
		steps: [
			{
				headline: 'Scan QR-Code on the order bag',
				textContent: 'Scan the QR-Code on the order bag to confirm that you have sealed the bag correctly.',
				image: '/basket-service-1.png',
			}
		]
	},
	PICKUP_ORDER_CREATED_INSTRUCTIONS: {
		steps: [
			{
				headline: 'Shopper will arrive at your address',
				textContent:
					'If you have a prescription, a shopper will come to your address to collect it. Have your prescription ready to hand over. The shopper will show you a QR code on their phone - scan it to confirm they are the right person.',
				image: '/basket-service-1.png',
			},
			{
				headline: 'Medication collection at pharmacy',
				textContent:
					'The shopper will go to the pharmacy to collect your medication. You can track their progress in the app.',
				image: '/basket-service-2.png',
			},
			{
				headline: 'Delivery confirmation',
				textContent:
					'Once the shopper returns with your medication, they will come back to your address. Scan the QR code on your order bag to confirm you have received the correct medication and complete the delivery.',
				image: '/images/SuccessThumbsUp.png',
			},
		]
	},
	COLLECT_ORDER_CREATED_INSTRUCTIONS: {
		steps: [
			{
				headline: 'Pharmacy will prepare your order',
				textContent:
					'No lines, no waiting time. The pharmacy will have your ordeer packaged and waiting for you to pickup.',
				image: '/basket-service-1.png',
			},
			{
				headline: 'Verify content before exiting',
				textContent:
					'Please  verify the package content before exiting the pharmacy just to be extra sure.',
				image: '/basket-service-2.png',
			},
		]
	},
	MAIL_ORDER_CREATED_INSTRUCTIONS: {
		steps: [
			{
				headline: 'Order will be sent to your location',
				textContent:
					'You order will be sealed by the pharmacy and sent to you by mail.',
				image: '/basket-service-1.png',
			},
			{
				headline: 'Verify content on first retrieval',
				textContent:
					'Please make sure you verify content as soon as you get your package and report any missing/damaged goods.',
				image: '/basket-service-1.png',
			}
		]
	},
	PHARMACY_SCAN_BAG_INSTRUCTIONS: {
		steps: [
			{
				headline: 'Get bag from storage unit',
				textContent:
					'Bring the customer\'s bag and hand it to him/her. Please make sure you get the correct one.',
				image: '/basket-service-1.png',
			},
			{
				headline: 'Scan QR-Codes of all bags belonging to the order',
				textContent:
					'To verify that the order has been handed to customer, all bags should be scanned.',
				image: '/basket-service-1.png',
			},
		]
	},
	PACKAGE_ORDER_PROCESSING_STARTED_INSTRUCTIONS: {
		steps: [
			{
				headline: 'Check the prescription',
				textContent:
					'Carefully check that the items in the order match the prescription. Ensure that all medications, quantities, and packaging are correct and correspond to what is listed on the prescription before proceeding.',
				image: '/basket-service-1.png',
			},
		]
	},
	PICKUP_IDENTIFY_SHOPPER_INSTRUCTIONS: {
		steps: [
			{
				headline: 'Identify the Shopper',
				textContent:
					'Proin sed blandit eros. Phasellus ac nisl enim. Sed sit amet quam bibendum, accumsan enim sit amet, maximus sapien. Vivamus mauris risus, malesuada id quam aliquet, rhoncus fermentum turpis. Fusce accumsan eu diam a aliquam. Aliquam congue fringilla libero, venenatis egestas elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. In nec ultricies risus.',
				image: '/basket-service-1.png',
			},
			{
				headline: 'Scan the QR Code',
				textContent:
					'Proin sed blandit eros. Phasellus ac nisl enim. Sed sit amet quam bibendum, accumsan enim sit amet, maximus sapien. Vivamus mauris risus, malesuada id quam aliquet, rhoncus fermentum turpis. Fusce accumsan eu diam a aliquam. Aliquam congue fringilla libero, venenatis egestas elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. In nec ultricies risus.',
				image: '/basket-service-1.png',
			},
		]
	},
	VERIFY_ORDER_CONTENT: {
		steps: [
			{
				headline: 'Verify order products',
				textContent:
					'Scan the barcode of each product using your pharmacy terminal to verify products.',
				image: '/basket-service-1.png',
			}
		]
	}
};

const USER_ROLES = {
	PHARMACY_ROLE: 1,
	CONSUMER_ROLE: 5,
	SHOPPER_ROLE: 4
};

const ORDER_STATUS = {
	OPEN: 0,
	MATCHING_PHARMACY: 1,
	PHARMACY_MATCHED: 2,
	BEING_PREPARED: 3,
	PREPARED: 4,
	SHOPPER_MATCHED: 5,
	SHOPPER_ARRIVED_AT_CUSTOMER: 6,
	SHOPPER_IDENTIFIED_BY_CUSTOMER: 7,
	SHOPPER_ARRIVED_AT_PHARMACY: 8,
	SHOPPER_IDENTIFIED_BY_PHARMACY: 9,
	ORDER_CONFIRMED_BY_PHARMACY: 10,
	ORDER_CONFIRMED_BY_SHOPPER: 11,
	SHOPPER_ARRIVED_AT_CUSTOMER_WITH_PACKAGE: 12,
	SHOPPER_IDENTIFIED_BY_CUSTOMER_WITH_PACKAGE: 13,
	ORDER_CONFIRMED_BY_SHOPPER_WITH_PACKAGE: 14,
	DONE: 15,
	CANCELED: 16,
	ERROR: 17
};

const SCAN_OPTIONS = {
	QR_CODE: 'QR-Code',
	PRESCRIPTION: 'Prescription'
};

const DELIVERY_TYPES = {
	BRINGZZ_PICKUP: 0,
	CLICK_AND_COLLECT: 1,
	MAIL_DELIVERY: 2
};

// Keep the constant for backward compatibility
const DELIVERY_TYPES_LABELS = {
	[DELIVERY_TYPES.BRINGZZ_PICKUP]: 'Bringzz Pickup',
	[DELIVERY_TYPES.CLICK_AND_COLLECT]: 'Click & Collect',
	[DELIVERY_TYPES.MAIL_DELIVERY]: 'Mail Delivery'
};

// Add the function for new translation-aware usage
const getDeliveryTypeLabel = (type, t) => {
	const TRANSLATED_DELIVERY_TYPES_LABELS = {
		[DELIVERY_TYPES.BRINGZZ_PICKUP]: t('component.delivery.types.bringzz_pickup'),
		[DELIVERY_TYPES.CLICK_AND_COLLECT]: t('component.delivery.types.click_and_collect'),
		[DELIVERY_TYPES.MAIL_DELIVERY]: t('component.delivery.types.mail_delivery')
	};
	return TRANSLATED_DELIVERY_TYPES_LABELS[type];
};

module.exports = {
	DefaultMenuList, SCAN_OPTIONS, PharmacistMenuList, hoursOptions, minutesOptions, INSTRUCTIONS, USER_ROLES, ORDER_STATUS, DELIVERY_TYPES, DELIVERY_TYPES_LABELS, getDeliveryTypeLabel
};
